import React, { useMemo } from 'react';
import { Tooltip } from '@primer/react';
import classNames from 'classnames';
import Label from './Label';

export const ExternalLink = ({
  className, 
  children,
  to,
  bold = false,
  openInNewTab = false,
  size = 'md',
  color = 'brand',
  hoverColor = 'highlighted',
  activeColor = 'faded-brand',
  backgroundColor = null,
  isJupyterEnabled = true,
}) => {
  const newTabProps = openInNewTab ? {
    target: '_blank',
    rel: 'noopener',
  } : {};

  const renderLabel = useMemo(() => {
    if (isJupyterEnabled) {
      return (
        <Label
          className={classNames(`cursor-pointer hover:text-${hoverColor} active:text-${activeColor}`, className)}
          bold={bold}
          size={size}
          color={color}
        >
          { children }
        </Label>
      )
    }

    return (
      <Tooltip aria-label="JupyterHub integration for Helm-based installation coming soon!">
        <Label
          className={classNames(`cursor-pointer ${backgroundColor}`, className)}
          bold={bold}
          size={size}
          color={color}
        >
          { children }
        </Label>
      </Tooltip>
    )
  }, [children, activeColor, bold, className, color, hoverColor, isJupyterEnabled, size, backgroundColor])

  return (
    <a href={isJupyterEnabled ? to : null} {...newTabProps}>
      {renderLabel}
    </a>
  )
}

export default ExternalLink;
